import React, { useState, useEffect } from 'react';
import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

const CarouselContainer = styled(Box)({
  position: 'absolute',
  inset: 0,
  width: '100%',
  height: '100%',
  zIndex: -2,
});

const Slide = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'active',
})(({ active }) => ({
  position: 'absolute',
  inset: 0,
  opacity: active ? 1 : 0,
  transition: 'opacity 1s ease-in-out',
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  backgroundRepeat: 'no-repeat',
  filter: 'brightness(0.7) saturate(1.2)',
}));

const DotsContainer = styled(Box)({
  position: 'absolute',
  bottom: 160,
  left: 0,
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
  gap: 12,
  zIndex: 20,
});

const Dot = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'active',
})(({ active }) => ({
  width: 14,
  height: 14,
  borderRadius: '50%',
  backgroundColor: active ? '#e97c07' : 'rgba(255,255,255,0.5)',
  border: '2px solid rgba(255,255,255,0.8)',
  cursor: 'pointer',
  transition: 'all 0.3s ease',
  boxShadow: '0 2px 6px rgba(0,0,0,0.3)',
  transform: active ? 'scale(1.2)' : 'scale(1)',
  '&:hover': {
    backgroundColor: active ? '#e97c07' : 'rgba(255,255,255,0.8)',
  },
}));

const slides = [
  { image: '/images/image1.jpg' },
  { image: '/images/image2.jpg' },
  { image: '/images/image3.jpg' },
  { image: '/images/image4.jpg' },
];

export default function Carousel() {
  const [currentSlide, setCurrentSlide] = useState(0);
  // Solo cargamos imágenes que ya se hayan visto (progressive loading)
  const [loadedSlides, setLoadedSlides] = useState(() => new Set([0]));

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => {
        const next = (prev + 1) % slides.length;
        setLoadedSlides((old) => {
          if (old.has(next)) return old;
          const s = new Set(old);
          s.add(next);
          return s;
        });
        return next;
      });
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  // Precargamos la siguiente slide 500ms después del montaje para tenerla lista
  useEffect(() => {
    const t = setTimeout(() => {
      setLoadedSlides((old) => {
        if (old.has(1)) return old;
        const s = new Set(old);
        s.add(1);
        return s;
      });
    }, 500);
    return () => clearTimeout(t);
  }, []);

  return (
    <>
      <CarouselContainer>
        {slides.map((slide, index) => (
          <Slide
            key={index}
            active={currentSlide === index ? 1 : 0}
            sx={{
              backgroundImage: loadedSlides.has(index) ? `url(${slide.image})` : 'none',
            }}
          />
        ))}
      </CarouselContainer>

      <DotsContainer>
        {slides.map((_, index) => (
          <Dot
            key={index}
            active={currentSlide === index}
            onClick={() => {
              setCurrentSlide(index);
              setLoadedSlides((old) => {
                if (old.has(index)) return old;
                const s = new Set(old);
                s.add(index);
                return s;
              });
            }}
          />
        ))}
      </DotsContainer>
    </>
  );
}
